<div class="modal-header">
  <h2 class="modal-title" mat-dialog-title>
    <span *ngIf="data.config" trans>Update image widget</span>
    <span *ngIf="!data.config">Add image widget</span>
  </h2>
  <button type="button" (click)="close()" class="close-button no-style" tabindex="-1">
    <mat-icon svgIcon="close"></mat-icon>
  </button>
</div>

<form (ngSubmit)="createOrUpdate()" [formGroup]="form" ngNativeValidate>
  <div mat-dialog-content class="many-inputs">
    <upload-image-control formControlName="url"></upload-image-control>

    <div class="input-container">
      <label for="image-widget-type" class="capitalize" trans>Type</label>
      <select id="image-widget-type" formControlName="type">
        <option value="default" trans>Default</option>
        <option value="avatar" trans>Avatar</option>
      </select>
    </div>

    <div class="input-container">
      <label for="image-widget-link" cdkFocusInitial class="capitalize" trans>Destination Url</label>
      <input type="url" id="image-widget-link" placeholder="Optional..." trans-placeholder formControlName="destinationUrl" />
    </div>
  </div>

  <div class="buttons right" mat-dialog-actions>
    <button (click)="close()" type="button" mat-button class="button cancel cancel-button" trans>
      Cancel
    </button>
    <button
      type="submit"
      mat-raised-button
      color="accent"
      [disabled]="editor.loading$ | async"
      class="button primary submit-button"
    >
      <span *ngIf="data.config" trans>Update</span>
      <span *ngIf="!data.config" trans>Add</span>
    </button>
  </div>
</form>
